import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.css']
})
export class CheckboxListComponent implements OnInit, OnChanges, AfterViewInit {

  public selectedItems: Array<any> = [];
  form: FormGroup;
  itemListSearch: string;
  filteredItems: Array<any> = [];
  @Input() dependency?: any;
  @Input() existingConfig?: any[] = [];
  @Output() existingConfigChange = new EventEmitter<any[]>();
  @Input() settings?: ICheckboxListSettings;
  @Input() itemsData?: any[] = [];
  @Output() selected: EventEmitter<any[]> = new EventEmitter<any>();

  get itemsFormArray() {
    return this.form.controls.items as FormArray;
  }

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.addCheckboxes();
  }

  ngAfterViewInit() {
    if (this.form) {
      this.form.controls.checkboxSelectAll.reset();
      this.form.controls.items.reset();
    }
    this.selectConfiguredItems();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['existingConfig'] || changes['dependency']) {
      this.existingConfigChange.emit(this.existingConfig);
      if (this.form) {
        this.form.controls.checkboxSelectAll.reset();
        this.form.controls.items.reset();
      }
      if (changes['existingConfig'] && this.form) {
        this.selectConfiguredItems();
        setTimeout(() => {  this.getSelectedItems(); }, 300);
      }
    }
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      items: new FormArray([]),
      checkboxSelectAll: [],
    });
  }

  private addCheckboxes() {
    this.itemsData.forEach(() => this.itemsFormArray.push(new FormControl(false)));
  }

  private selectConfiguredItems() {
    if (this.existingConfig) {
      if (this.existingConfig.length === this.itemsData.length) {
        this.form.controls.checkboxSelectAll.setValue(true);
      }
      const mappedItems = this.itemsData.map(item => item[this.settings.idPropertyName]);
      this.existingConfig.forEach( selectedItem => {
        const controlPosition = mappedItems.indexOf(selectedItem);
        if (controlPosition !== -1) { this.form.get('items')['controls'][controlPosition].setValue(true); }
      });
    }
  }

  private selectAll(element) {
    const selectAllChecked = element.target.checked;
    const values = [];
    let i = 0;
    this.itemsFormArray.controls.forEach( control => {
      const id = 'lbl' + this.settings.listOf + this.itemsData[i][this.settings.idPropertyName];
      const chbxElement = <HTMLElement>document.getElementById(id);
      values.push(chbxElement.hasAttribute('hidden') ? control.value : selectAllChecked);
      i++;
    });
    this.itemsFormArray.setValue(values);
    this.getSelectedItems();
  }

  private onChbxChange() {
    const selectAll = (this.itemsFormArray.value.indexOf(false)) !== -1 || (this.itemsFormArray.value.indexOf(null) !== -1);
    if (this.filteredItems.length === 0) {
      this.form.patchValue({
        checkboxSelectAll: !selectAll,
      });
    } else {
      this.form.patchValue({
        checkboxSelectAll: this.checkAllResults()
      });
    }
    this.getSelectedItems();
  }

  private filterItems() {
    if (this.itemListSearch !== '' && this.itemListSearch !== undefined) {
    this.filteredItems = this.itemsData.filter(item => {
      return item[this.settings.namePropertyName].toLowerCase().includes(this.itemListSearch.toLowerCase());
    });
    this.itemsData.forEach(item => {
      const id = 'lbl' + this.settings.listOf + item[this.settings.idPropertyName];
      if (this.filteredItems.includes(item)) {
        document.getElementById(id).removeAttribute('hidden');
      } else {
        document.getElementById(id).setAttribute('hidden', 'true');
      }
    });
    this.form.patchValue({
      checkboxSelectAll: this.checkAllResults()
    });
    } else {
      this.filteredItems = [];
      this.itemsData.forEach(item => {
        const id = 'lbl' + this.settings.listOf + item[this.settings.idPropertyName];
        document.getElementById(id).removeAttribute('hidden');
      });
      this.onChbxChange();
    }
  }

  checkAllResults(): boolean {
    if (this.filteredItems.length < 1) { return false; }
    let res = true;
    this.filteredItems.forEach( item => {
      const chkId = 'chk' + this.settings.listOf + item[this.settings.idPropertyName] ;
      const chkElement = <HTMLInputElement>document.getElementById(chkId);
      if (!chkElement.checked) {
        res = false;
        return;
      }
    });
    return res;
  }

  getSelectedItems() {
    this.selectedItems = this.form.value.items
      .map((checked, i) => checked ? this.itemsData[i][this.settings.idPropertyName] : null)
      .filter(v => v !== null);
    this.selected.emit(this.selectedItems);
  }

}

export interface ICheckboxListSettings {
  height?: number;
  idPropertyName?: string;
  namePropertyName?: string;
  listTitle?: string;
  inputSearchId?: string;
  checkboxClass?: string;
  listOf: string;
}
